module.exports = __webpack_public_path__ + "img/logo-recuperi-2.a6d4c69b.png";